import { Helmet } from 'react-helmet-async'

import {
  OPEN_GRAPH_DEFAULT_IMAGE,
  OPEN_GRAPH_SITE_NAME,
} from '@blocktickets/shared-utils'

export default function OpenGraph({ title, description, image, url }) {
  const pageUrl =
    url ||
    (typeof window !== 'undefined'
      ? window.location.href.split('#')[0].split('?')[0]
      : '')
  const socialImage = image || OPEN_GRAPH_DEFAULT_IMAGE

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:site_name" content={OPEN_GRAPH_SITE_NAME} />
      <meta property="og:type" content="website" />
      {pageUrl ? <meta property="og:url" content={pageUrl} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={socialImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />
    </Helmet>
  )
}
